export const COLORS = {
  ink: '#08081B',
  muted: '#63637D',
  faint: '#7A7A93',
  bg: '#F6F6F8',
  panel: '#FAFAFD',
  navy: '#2A2A8B',
  indigo: '#2f2f9d',
  blue: '#117AC0',
  orange: '#FB7B04',
  hairline: 'rgba(8, 8, 27, 0.12)',
  hairlineSoft: 'rgba(8, 8, 27, 0.08)',
  divider: 'rgba(8, 8, 27, 0.15)',
  link: '#4B4BC4',
};

export const CARD_SHADOW =
  '0 2px 1px -1px rgba(0,0,0,0.20), 0 1px 1px rgba(0,0,0,0.14), 0 1px 3px rgba(0,0,0,0.12)';

export type TrendCategory = 'rising' | 'flat' | 'falling' | 'met' | 'na';

export const TREND_STYLES: Record<TrendCategory, { bg: string; fg: string }> = {
  rising: { bg: '#BBE7B1', fg: '#132B0D' },
  met: { bg: '#A8F0E2', fg: '#083029' },
  flat: { bg: '#C1C1CD', fg: '#08081B' },
  falling: { bg: '#FBD5C4', fg: '#5B1A00' },
  na: { bg: '#C1C1CD', fg: '#08081B' },
};

export const WARNING_CHIP = { bg: '#FEE59A', fg: '#4D1C00' };

export const LTEL_BANNER = {
  bg: '#FBD5C4',
  border: 'rgba(215, 79, 30, 0.25)',
  accent: '#D74F1E',
  fg: '#5B1A00',
};

export const STATUS_PILL = { bg: '#FBE6A6', fg: '#6B4E00' };
export const DRAFT_PILL = { bg: '#F7C08D', fg: '#512100' };
export const WIDA_ONLY_PILL = { bg: '#E1EAFB', fg: '#23347A' };

export const NEXT_BOX = { bg: '#CCE8FA', border: '#CCE8FA', label: '#072254' };
export const NOW_BOX = { bg: COLORS.bg, border: COLORS.bg, label: COLORS.muted };


export const INFO_BOX = { bg: '#F2F2F6', border: COLORS.hairlineSoft, accent: COLORS.navy };

export const RESET_PILL = {
  full: { bg: '#505071', fg: '#FFFFFF' },
  mini: { bg: '#C1C1CD', fg: '#3D3D52' },
};

export const PLAN_CHIP = {
  grey: { bg: '#E3E3E8', fg: '#4A4A5F' },
  suggested: { bg: '#EFEFFA', fg: COLORS.navy },
  warn: WARNING_CHIP,
  draft: DRAFT_PILL,
  final: TREND_STYLES.rising,
};

export const PLAN_INFO_BAR = { bg: NEXT_BOX.bg, border: NEXT_BOX.bg, fg: NEXT_BOX.label, icon: COLORS.blue };

export const PLAN_SUCCESS = TREND_STYLES.rising.fg;
